import { sortGridComponent } from './sort-grid.component';
import './sort-grid.scss';

export const sortgrid = angular
.module("common.components.sortGrid", [])
.component("sortgrid", sortGridComponent)
.name;



// WEBPACK FOOTER //
// ./src/app/common/components/sort-grid/sort-grid.module.js